module.exports = __webpack_public_path__ + "img/UntenNebenFuesseUntenTransp.d85f5685.png";